"use strict";

import angular from "angular";

import template from "./cookie-consent.component.html";
import "./themes/cookie-consent.component.scss";

import { analyticsTargets } from "../../../presentation/services/CookieConsent/analytics-targets";
import { CookieConsent } from "../../../presentation/services/CookieConsent/CookieConsent";

/** Na própria Política de Privacidade o aviso não abre sozinho: taparia o texto que a pessoa quer ler. */
export const PRIVACY_POLICY_STATE = "nucont.privacyPolicy";
const PRIVACY_POLICY_PATH = "/politica-de-privacidade";

const BODY_CLASS = "cookie-consent-open";

/**
 * Aviso de cookies (LGPD): janela no meio da tela, sobre a página escurecida, até a pessoa escolher
 * Aceitar ou Recusar — não fecha clicando fora nem com Esc. Substitui o aviso que vinha com o script
 * da HubSpot.
 *
 * Quem já respondeu e reabre pela Política de Privacidade ("Preferências de cookies") pode fechar
 * sem mudar a escolha.
 */
export class CookieConsentComponent {
    constructor($rootScope, $transitions, $state, $document, $timeout) {
        this.$rootScope = $rootScope;
        this.$transitions = $transitions;
        this.$state = $state;
        this.$document = $document;
        this.$timeout = $timeout;
        this.consent = new CookieConsent({ analytics: analyticsTargets });
    }

    $onInit() {
        this.pending = this.consent.isPending();
        this.reopened = false;
        // Na primeira carga o estado ainda não resolveu: o caminho evita o aviso piscar sobre a política.
        this.onPolicyPage =
            this.$state.current?.name === PRIVACY_POLICY_STATE ||
            this.$document[0].location?.pathname === PRIVACY_POLICY_PATH;
        this.offTransition = this.$transitions.onSuccess({}, (transition) => {
            this.onPolicyPage = transition.to().name === PRIVACY_POLICY_STATE;
            this.sync();
        });
        // A política de privacidade reabre o aviso ("Preferências de cookies").
        this.unsubscribe = this.$rootScope.$on("COOKIE_CONSENT_OPEN", () => {
            this.reopened = true;
            this.sync();
        });
        this.sync();
    }

    $onDestroy() {
        this.unsubscribe?.();
        this.offTransition?.();
        this.lockPage(false);
    }

    sync() {
        const wasVisible = this.visible;
        this.visible = this.reopened || (this.pending && !this.onPolicyPage);
        this.canDismiss = !this.pending;
        this.lockPage(this.visible);
        if (this.visible && !wasVisible) this.focusChoice();
    }

    /** Página por trás parada: sem rolagem enquanto a escolha não é feita. */
    lockPage(locked) {
        this.$document.find("body").toggleClass(BODY_CLASS, locked);
    }

    focusChoice() {
        this.$timeout(() => {
            this.$document[0].querySelector("#CookieConsent .cookie-consent__button--primary")?.focus();
        });
    }

    accept() {
        this.consent.accept();
        this.close();
    }

    refuse() {
        this.consent.refuse();
        this.close();
    }

    dismiss() {
        if (this.canDismiss) this.close();
    }

    close() {
        // Respondeu: fecha mesmo se o navegador não deixou gravar (a escolha vale nesta página).
        this.pending = false;
        this.reopened = false;
        this.sync();
    }
}

CookieConsentComponent.$inject = ["$rootScope", "$transitions", "$state", "$document", "$timeout"];

const name = "cookieConsentComponent";
const def = {
    bindings: {},
    controller: CookieConsentComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
